import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import {
    getTheme,
    isFullscreen,
    toggleFullscreen,
    toggleMiniSidebar,
    toggleMobileSidebar,
    toggleTheme,
} from './layoutUtils'
import useDropdown from './useDropdown'

const NOTIFICATIONS = [
    {
        id: 1,
        title: 'Payment received',
        message: 'INV-2026-0241 was paid by TechStart Ltd',
        time: '4 min ago',
    },
    {
        id: 2,
        title: 'Invoice sent',
        message: 'INV-2026-0235 was emailed to Global Solutions Inc',
        time: '8 min ago',
    },
    {
        id: 3,
        title: 'Overdue reminder',
        message: 'INV-2026-0218 is past due for Bright Media',
        time: '15 min ago',
    },
]

const Topbar = () => {
    const [theme, setTheme] = useState(getTheme)
    const [fullscreen, setFullscreen] = useState(isFullscreen)
    const [notifications, setNotifications] = useState(NOTIFICATIONS)
    const [searchQuery, setSearchQuery] = useState('')
    const languageDropdown = useDropdown()
    const notificationDropdown = useDropdown()

    const navigate = useNavigate()

    useEffect(() => {
        const handleFullscreenChange = () => setFullscreen(isFullscreen())
        document.addEventListener('fullscreenchange', handleFullscreenChange)
        return () => document.removeEventListener('fullscreenchange', handleFullscreenChange)
    }, [])

    useEffect(() => {
        // Check for token every 5 seconds to ensure active session
        const interval = setInterval(() => {
            const token = Cookies.get('token')
            if (!token) {
                navigate('/lockscreen', { replace: true })
            }
        }, 5000)

        return () => clearInterval(interval)
    }, [navigate])

    const handleThemeToggle = () => {
        const next = toggleTheme()
        setTheme(next)
    }

    const handleFullscreenToggle = (e) => {
        e.preventDefault()
        toggleFullscreen()
    }

    const dismissNotification = (id) => {
        setNotifications((current) => current.filter((item) => item.id !== id))
    }

    return (
        <header className="navbar-header">
            <div className="page-container topbar-menu">
                <div className="d-flex align-items-center gap-2">
                    <Link to="/" className="logo">
                        <span className="logo-light">
                            <span className="logo-lg"><img src="/assets/img/logo.svg" alt="logo" /></span>
                            <span className="logo-sm"><img src="/assets/img/logo-small.svg" alt="small logo" /></span>
                        </span>
                        <span className="logo-dark">
                            <span className="logo-lg"><img src="/assets/img/logo-white.svg" alt="dark logo" /></span>
                        </span>
                    </Link>

                    <button
                        type="button"
                        id="mobile_btn"
                        className="mobile-btn btn p-0 border-0 bg-transparent d-lg-block"
                        onClick={(e) => {
                            e.preventDefault()
                            if (window.innerWidth >= 992) {
                                toggleMiniSidebar()
                            } else {
                                toggleMobileSidebar()
                            }
                        }}
                        aria-label="Toggle menu"
                    >
                        <i className="ti ti-menu-deep fs-24" />
                    </button>

                    <button
                        type="button"
                        className="sidenav-toggle-btn btn p-0"
                        id="toggle_btn2"
                        onClick={toggleMiniSidebar}
                        aria-label="Toggle sidebar"
                    >
                        <i className="ti ti-chevron-left-pipe" />
                    </button>

                    
                </div>

                <div className="d-flex align-items-center">
                    <div className="header-item d-flex d-lg-none me-2">
                        <button
                            type="button"
                            className="topbar-link btn btn-icon"
                            onClick={() => document.getElementById('topbar-search-input')?.focus()}
                            aria-label="Search"
                        >
                            <i className="ti ti-search fs-16" />
                        </button>
                    </div>


                    <div className="header-item">
                        <div className="me-2">
                            <button
                                type="button"
                                className="btn topbar-link border-0 bg-transparent"
                                id="btnFullscreen"
                                onClick={handleFullscreenToggle}
                                aria-label={fullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
                            >
                                <i className={`ti ${fullscreen ? 'ti-minimize' : 'ti-maximize'} fs-16`} />
                            </button>
                        </div>
                    </div>

                    <div className="header-item d-none d-sm-flex me-2">
                        <button
                            type="button"
                            className="topbar-link btn btn-icon border-0 bg-transparent"
                            id="light-dark-mode"
                            onClick={handleThemeToggle}
                            aria-label="Toggle theme"
                        >
                            <i className={`ti ${theme === 'dark' ? 'ti-sun' : 'ti-moon'} fs-16`} />
                        </button>
                    </div>

                    <div className="header-item">
                        <Link to="/settings" className="btn topbar-link">
                            <i className="ti ti-settings fs-16" />
                        </Link>
                    </div>
                </div>
            </div>

            <div className="d-lg-none px-3 pb-2">
                <input
                    id="topbar-search-input"
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search invoices, clients..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />
            </div>
        </header>
    )
}

export default Topbar

